import { render, staticRenderFns } from "./paginate.vue?vue&type=template&id=3b822505"
import script from "./paginate.vue?vue&type=script&lang=js"
export * from "./paginate.vue?vue&type=script&lang=js"
import style0 from "./paginate.vue?vue&type=style&index=0&id=3b822505&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports